var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ic_Custom_document",
    "data-name": "Ic_Custom document",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.52,
    height: 18.263,
    viewBox: "0 0 12.52 18.263",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_346",
    "data-name": "Path 346",
    d: "M196.44,56V74.263h8.118v-4.28a.457.457,0,0,1,.457-.457h3.945V56Zm1.5,1.848h9.138a.457.457,0,1,1,0,.913h-9.1a.457.457,0,1,1-.043-.913Zm0,2.454h9.138a.457.457,0,1,1,0,.913h-9.1a.457.457,0,1,1-.043-.913Zm0,2.454h9.138a.457.457,0,1,1,0,.913h-9.1a.457.457,0,0,1-.043-.913Zm0,2.454h9.138a.457.457,0,1,1,0,.913h-9.1a.457.457,0,0,1-.043-.913Zm-.043,2.461h5.258a.457.457,0,1,1,0,.913h-5.172a.459.459,0,0,1-.086-.913Z",
    transform: "translate(-196.44 -56)",
    fill: "#3957af"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_347",
    "data-name": "Path 347",
    d: "M417.99,410.18h3.267l-3.267,3.51Z",
    transform: "translate(-408.959 -395.742)",
    fill: "#3957af"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomDocument);
export default __webpack_public_path__ + "static/media/custom_document.2850aea5cfa22fe0bcfbf2578788aa21.svg";
export { ForwardRef as ReactComponent };